export const ENVIRONMENTS = {
  DEV: 'dev',
  TEST: 'test',
  UAT: 'uat',
  PROD: 'prod',
} as const;

export type Environment = (typeof ENVIRONMENTS)[keyof typeof ENVIRONMENTS];

export const isValidEnvironment = (env: string): env is Environment => {
  return Object.values(ENVIRONMENTS).includes(env as Environment);
};
